<template>
  <v-data-table v-model="selected" item-key="id" :headers="headers" :items="list">
    <template v-slot:items="props">
      <td style="width: 5%">
        <v-checkbox v-model="props.selected" primary hide-details @change="saveToSchema" />
      </td>

      <td>{{ props.item.name }}</td>
    </template>
  </v-data-table>
</template>
<script>
// @vuese
// @group Components/Forms
// Input na liste wybranej encji
export default {
  props: {
    // nazwa modułu
    moduleName: {
      type: String,
      required: true
    },
    // schema
    schema: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      headers: [
        {
          text: '',
          sortable: false
        },
        {
          text: 'Nazwa',
          value: 'name'
        }
      ],
      selected: []
    };
  },
  computed: {
    list() {
      return this.$store.state[this.moduleName].list;
    }
  },
  methods: {
    // @vuese
    // Ładowanie listy
    getList() {
      this.$store.dispatch(`${this.moduleName}/list`, { count: 0 }).catch(err =>
        this.$store.dispatch('notifyError', {
          title: 'Wystąpił błąd podczas pobierania listy.'
        })
      );
    },
    // @vuese
    // Zapisuje do schema
    saveToSchema() {
      const list = this.selected.map(item => item.id);
      this.schema.$model = JSON.stringify({ list });
    },
    // @vuese
    // Wczytuje z schema
    loadFromSchema() {
      if (this.schema.$model) {
        const list = JSON.parse(this.schema.$model).list;
        this.selected = list.map(item => {
          return { id: item };
        });
      }
    }
  },
  mounted() {
    this.getList();
    this.loadFromSchema();
  }
};
</script>
